class NotificationRequest{
    NotificationURL(){
        return process.env.REACT_APP_BASEURL+"Notification"
    }
}
export const {NotificationURL}=new NotificationRequest()